import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureNavigationButton',
  props: {
  isSelected: { type: Boolean, required: false, default: false },
  disabled: { type: Boolean, required: false, default: false },
  title: { type: String, required: true }
},
  emits: ["onClick"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    ref: "button",
    class: _normalizeClass({ selected: __props.isSelected }),
    disabled: __props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick')))
  }, [
    _createVNode(TooltipStandardV2, {
      text: __props.title,
      arrowPosition: 'center-right',
      verticalOffset: 2,
      horizontalOffset: 3,
      style: { flexGrow: 0, padding: '11.5px' },
      disabledTooltip: __props.isSelected
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _: 3
    }, 8, ["text", "disabledTooltip"])
  ], 10, _hoisted_1))
}
}

})